import { isPracticeMode } from "@utils/practice/practiceMode";

export async function getLineProfileByToken(accessToken: string) {
  // 客服練習模式：回傳假的 LINE 個資（不打真實 LINE API），讓姓名自動帶入如同正式流程。
  if (isPracticeMode()) {
    return { status: "success", data: { displayName: "練習客戶", userId: "U_PRACTICE", pictureUrl: "" }, message: "練習模式" };
  }
  try {
    const response = await fetch("https://api.line.me/v2/profile", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      return { status: "error", data: null, message: "LINE API 錯誤" };
    }

    const profileData = await response.json();

    return { status: "success", data: profileData, message: "取得成功" };
  } catch (error) {
    console.error("getLineProfileByToken error:", error);
    return { status: "error", data: null, message: "取得錯誤" };
  }
}
